import { QueryLoader } from "@Light/components/app/QueryLoader";
import { useLight } from "@Light/services/light";
import { AccountContext } from "./context";

export type WithAccountProps = {
  children: React.ReactNode;
};

export const WithAccount: React.FC<WithAccountProps> = ({ children }) => {
  const { useGetAccountQuery } = useLight();
  const account = useGetAccountQuery();
  return (
    <QueryLoader
      queries={[account]}
      errorMessage="Error loading account data. Please try again later."
      fullHeight
    >
      <AccountContext.Provider value={account.data}>
        {children}
      </AccountContext.Provider>
    </QueryLoader>
  );
};
